import { useRef, useState } from 'react'

export default function usePendingSave() {
  const locked = useRef(false)
  const [isSaving, setIsSaving] = useState(false)
  const setSaving = (value) => { locked.current = value; setIsSaving(value) }
  const runSave = async (save) => {
    if (locked.current) return
    setSaving(true)
    try {
      return await save()
    } finally {
      setSaving(false)
    }
  }
  return [isSaving, runSave]
}
